import 'babel-polyfill';
import 'core-js/features/url-search-params'
import 'core-js/es/promise/all-settled'

import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom'
import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk'
import promiseMiddleware from 'redux-promise';
import multi from 'redux-multi'

import { Provider } from 'react-redux';
import axios from 'axios';

import './stylesheets/main.scss';

import { ClinicaStorageUtil } from './utils/clinica_storage_util';
import { initDraftCache } from './form_persistence_util';

//axios interceptor to all axios calls to prevent IE caching
axios.interceptors.request.use((config) => {
  var ts = +(new Date());
  var ret = config.url.replace(/(\?|&)_=.*?(&|$)/, "$1_=" + ts + "$2");
  config.url = ret + ((ret == config.url) ? (config.url.match(/\?/) ? "&" : "?") + "_=" + ts : "");
  return config;
});

//console.logs app version to browser console.
console.log("app v." + __VERSION__);

// Hydrate caches from IndexedDB BEFORE importing the reducer (which reads from cache at load time)
Promise.all([
  ClinicaStorageUtil.init(),
  initDraftCache(),
]).then(async () => {
  const { default: applicationReducer } = await import('./application_state');
  const { default: Routes } = await import('./router/routes');

  const store = createStore(applicationReducer, undefined,
    applyMiddleware(thunkMiddleware, promiseMiddleware, multi));

  render((
    <Provider store={store}>
      <Router>
        {Routes(store)}
      </Router>
    </Provider>
  ), document.getElementById('app'));
});
